import axiosInstance from "../../axiosInstance";
const BASE_URL = "/hrm/on_leave";

// Lấy tất cả nghỉ phép + filter + pagination
export const getAllOnLeaves = async (params = {}) => {
  try {
    const response = await axiosInstance.get(BASE_URL, { params });
    return response.data;
  } catch (error) {
    console.error("❌ Lỗi khi lấy danh sách nghỉ phép:", error);
    throw error.response?.data || error;
  }
};

// Danh sách chờ duyệt
export const getPendingOnLeaves = async (params = {}) => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/pending`, { params });
    return response.data;
  } catch (error) {
    console.error("❌ Lỗi khi lấy danh sách nghỉ phép chờ duyệt:", error);
    throw error.response?.data || error;
  }
};

// Lấy timeline duyệt
export const getOnLeaveTimeline = async (id) => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/${id}/timeline`);
    return response.data;
  } catch (error) {
    console.error("❌ Lỗi khi lấy timeline nghỉ phép:", error);
    throw error.response?.data || error;
  }
};


// Create leave request
export const createOnLeave = async (formData) => {
  try {
    const response = await axiosInstance.post(BASE_URL, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("❌ Lỗi khi tạo đơn nghỉ phép:", error);
    throw error.response?.data || error;
  }
};

// Approve
export const approveOnLeave = async (id, data) => {
  try {
    const { approver_id, approval_note = "" } = data || {};

    console.log("🚀 approveOnLeave gửi lên:", {
      approver_id,
      approval_note,
    });

    const response = await axiosInstance.put(`${BASE_URL}/${id}/approve`, {
      approver_id,
      approval_note,
    });

    return response.data;
  } catch (error) {
    console.error("❌ Lỗi khi phê duyệt nghỉ phép:", error);
    throw error.response?.data || error;
  }
};

// Reject
export const rejectOnLeave = async (id, data) => {
  try {
    const { approver_id, approval_note = "" } = data || {};

    console.log("🚀 rejectOnLeave gửi lên:", {
      approver_id,
      approval_note,
    });

    const response = await axiosInstance.put(`${BASE_URL}/${id}/reject`, {
      approver_id,
      approval_note,
    });

    return response.data;
  } catch (error) {
    console.error("❌ Lỗi khi từ chối nghỉ phép:", error);
    throw error.response?.data || error;
  }
};


// Delete leave
export const deleteOnLeave = async (id) => {
  try {
    const response = await axiosInstance.delete(`${BASE_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error("❌ Lỗi khi xóa đơn nghỉ phép:", error);
    throw error.response?.data || error;
  }
};

// Remaining annual leave
export const getRemainingAnnualLeave = async (employeeId) => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/remaining/${employeeId}`);
    return response.data;
  } catch (error) {
    console.error("❌ Lỗi khi lấy số phép năm còn lại:", error);
    throw error.response?.data || error;
  }
};
